import { useState, type FC } from "react";
import { useTranslation } from "@privacy/translations";
import Button from "@mui/material/Button";
import { PlusIcon } from "../../../shared/icons";
import { CreateUserDialog } from "../../../shared/CreateUserDialog";

export const CreateUserButton: FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDialogClose = () => setIsOpen(false);

  return (
    <>
      <Button data-testid="CreateUser.Button" startIcon={<PlusIcon size={16} />} onClick={() => setIsOpen(true)}>
        {t("CreateUser.Button")}
      </Button>

      {isOpen && <CreateUserDialog defaultEmail="" onCancel={handleDialogClose} onCreated={handleDialogClose} />}
    </>
  );
};
